module.exports = __webpack_public_path__ + "img/a.5dfcb816.svg";